var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmployeesInactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3846 1C16.3945 1 17.363 1.39509 18.0771 2.09835C18.7911 2.80161 19.1923 3.75544 19.1923 4.75C19.1923 5.74456 18.7911 6.69839 18.0771 7.40165C17.363 8.10491 16.3945 8.5 15.3846 8.5M18.0923 12.15C19.5339 12.6901 20.775 13.6485 21.6513 14.8985C22.5276 16.1485 22.998 17.631 23 19.15V21H20.4615M12.4231 4.75C12.4231 6.82107 10.7183 8.5 8.61538 8.5C6.51245 8.5 4.80769 6.82107 4.80769 4.75C4.80769 2.67893 6.51245 1 8.61538 1C10.7183 1 12.4231 2.67893 12.4231 4.75ZM16.2308 21H1V19.3333C1 17.3442 1.80233 15.4366 3.23049 14.03C4.65866 12.6235 6.59566 11.8333 8.61538 11.8333C10.6351 11.8333 12.5721 12.6235 14.0003 14.03C15.4284 15.4366 16.2308 17.3442 16.2308 19.3333V21Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmployeesInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/employees_inactive.ef1baf57c279a6f3c83b980ec47a6679.svg";